import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-14c.svg'

const data = {
  question: (
    <Fragment>
      There are brain, body, and social consequences of vaping/using
      e-cigarettes. Which of the following are potential{' '}
      <em>social consequences</em> of vaping and using e-cigarettes?
    </Fragment>
  ),
  inputType: 'checkbox',
  options: [
    {
      label: 'Becoming addicted',
    },
    {
      label: 'Losing trust of parents',
    },
    {
      label: 'Getting detention from school',
    },
    {
      label: 'Damaging lungs, mouth and throat',
    },
    {
      label: 'Getting kicked off the basketball team',
    },
    {
      label: 'Developing concentration and memory problems',
    },
  ],
}

const correctInput = {
  [data.question]: [
    data.options[1].label,
    data.options[2].label,
    data.options[4].label,
  ],
}

const feedback = {
  success: {
    title: 'Great!',
    body: '',
  },
  error: {
    title: 'Not quite.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 3',
  path: '/challenge/question-3',
  content: (
    <Fragment>
      <Intro title="Question 3" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question3.js